/**
 * TikTok Integration Module (Stories 11.1, 11.2)
 *
 * Barrel export for all TikTok OAuth, scopes, discovery, token-refresh, error, and adapter modules.
 * Single platform: tiktok-business (simpler than Meta/LinkedIn multi-platform).
 */

import { registerAdapter } from "../registry";
import { tiktokBusinessAdapter } from "./tiktok-business";

// Register TikTok Business adapter (Story 11.2)
registerAdapter("tiktok-business", tiktokBusinessAdapter);

// OAuth utilities
export {
  buildTikTokAuthUrl,
  exchangeTikTokCode,
  parseTikTokCallbackError,
  revokeTikTokToken,
  type TikTokAuthUrlOptions,
  type TikTokTokenResponse,
  type TikTokCallbackError,
} from "./oauth";

// Scopes
export {
  TIKTOK_SCOPES,
  TIKTOK_ORGANIC_SCOPES,
  TIKTOK_ADS_SCOPES,
  TIKTOK_PLATFORM_VALUES,
  TIKTOK_SCOPE_SEPARATOR,
  buildTikTokScopeString,
  parseTikTokScopes,
  validateTikTokScopes,
  type TikTokPlatform,
  type TikTokScope,
} from "./scopes";

// User info discovery
export {
  fetchTikTokUserInfo,
  type TikTokUserInfo,
} from "./discovery";

// Token refresh
export {
  refreshTikTokAccessToken,
  type TikTokRefreshResponse,
} from "./token-refresh";

// Error parsing
export {
  parseTikTokApiError,
  type TikTokApiError,
  type TikTokErrorType,
} from "./errors";

// TikTok Business Adapter (Story 11.2)
export {
  tiktokBusinessAdapter,
  TIKTOK_BUSINESS_METRICS,
  TIKTOK_BUSINESS_DIMENSIONS,
} from "./tiktok-business";

// TikTok Ads API Helpers (Story IMC-8)
export {
  fetchTikTokAdsReport,
  buildTikTokAdsHeaders,
  flattenAdsReportRow,
  parseAdsMetricValue,
  TIKTOK_ADS_METRICS,
  TIKTOK_ADS_DIMENSIONS,
  ALL_ADS_METRICS,
  ADS_DELIVERY_METRICS,
  ADS_VIDEO_METRICS,
  ADS_ENGAGEMENT_METRICS,
  ADS_CONVERSION_METRICS,
  ADS_ROAS_METRICS,
  ADS_SHOP_METRICS,
} from "./tiktok-ads";
